export const ChevronCalendarLeftIcon = () => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 0.5L1.75 5L6.25 9.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="16"
    />
  </svg>
);
